import $ from "jquery";
import "jquery-mask-plugin";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
    setEvents();
    renderLmsPassBank();
}

function setEvents() {
    $(document).on("click", ".js-btn-adminEthosBank-Individual", function () {
        const $tr = $(this).closest("tr");
        const personId = $tr.attr("data-personId");
        const personName = $tr.attr("data-personName");
        const programId = $tr.attr("data-programId");
        const programName = $tr.attr("data-programName");
        const courseEditionId = $tr.attr("data-courseEditionId");
        const courseEditionName = $tr.attr("data-courseEditionName");
        dataaccess
            .get({
                url: "/EthosBank/Person/" + personId + "/" + personName + "/Program/" + programId + "/" + programName + "/CourseEdition/" + courseEditionId + "/" + courseEditionName
            })
            .done(function (result) {
                $("#modifyEthosBank")
                    .find(".modal-content")
                    .html(result);
                $("#modifyEthosBank").modal("show");
            });

    });

    $(document).on("click","#btnUpdateEthosBank",function (e) {
        e.preventDefault();
        const $form = $(this).closest("form");

        if ($form.valid()) {
            const params = {
                contentType: dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                data: $form.serialize(),
                url: $form.attr("action"),
                successMsg: "Successfully adjusted licenses."
            };

            dataaccess.post(params).done(function() {
                $("#modifyEthosBank").modal("hide");
                renderLmsPassBank();
            });
        }
    });

}

function renderLmsPassBank() {
    dataaccess
        .get({
            url: "/person/lmspassbank/" + $("#personId").val()
        })
        .done(function (res) {
            $("#adminEthosBankContainer").html(res);
        });

}

export const ethosBankAdmin = {
    init: init
};
